import React from 'react';
import { Field } from 'react-final-form';
import { Checkbox } from '@eika/checkbox';
export const CheckboxField = _ref => {
  let {
    label,
    name,
    value,
    disabled,
    selected,
    onChangeOverride,
    id
  } = _ref;
  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    type: "checkbox",
    render: _ref2 => {
      let {
        input
      } = _ref2;
      return /*#__PURE__*/React.createElement(Checkbox, {
        disabled: disabled,
        name: name,
        label: label,
        value: value,
        checked: selected,
        onChange: event => onChangeOverride ? input.onChange(onChangeOverride(event)) : input.onChange(event),
        id: id || name
      });
    },
    disabled: disabled
  });
};